import type { FC } from 'react';
import { CONDITION_DESKTOP } from 'shared/common/constants';
import styled from 'styled-components';

type AnswerProps = {
  answer: string;
  question: string;
  id: string;
};

type AnswerListProps = {
  title: string;
  questions: AnswerProps[];
};

type AnswersListProps = {
  list: AnswerListProps[];
};

export const AnswersList: FC<AnswersListProps> = ({ list }) => (
  <>
    {list.map((item) => (
      <div key={item.title}>
        <AnswersTitle>{item.title}</AnswersTitle>
        <AnswersContent>
          {item.questions.map((question) => (
            <AnswerInner key={question.id}>
              <AnswerHeading id={question.id}>{question.question}</AnswerHeading>
              <Answer dangerouslySetInnerHTML={{ __html: question.answer }} />
            </AnswerInner>
          ))}
        </AnswersContent>
      </div>
    ))}
  </>
);

const AnswersTitle = styled.h3`
  font-size: 25px;
  line-height: 31px;
  font-weight: bold;
  margin-bottom: 30px;
  ${CONDITION_DESKTOP} {
    margin-bottom: 40px;
  }
`;

const AnswersContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 530px;
  margin-bottom: 90px;
`;

const AnswerHeading = styled.div`
  font-size: 17px;
  line-height: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #111;
`;

const Answer = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  color: #79818c;
  white-space: break-spaces;
  a {
    color: #8b33ff;
  }
`;

const AnswerInner = styled.div`
  &:not(:last-child) {
    margin-bottom: 40px;
    ${CONDITION_DESKTOP} {
      margin-bottom: 60px;
    }
  }
`;
